import gql from 'graphql-tag';

export const UPDATE_PAYMENT_TYPE = gql`
  mutation UpdatePaymentType($input: UpdateVOPaymentTypeInput!) {
    result: updateVOPaymentType(input: $input) {
      error
      success
    }
  }
`;
